import {gemStore} from 'app/gemStore';

import type {ModalComponentState} from './types';

export const openModalAction = (state: ModalComponentState) => gemStore.getState().openModal(state);
export const closeModalAction = () => gemStore.getState().closeModal();
